import { DayExperienceTaxonomy } from "@/models/DayExperienceTaxonomy";
import dayExperienceService from "@/services/day-experience.service";
import { ref } from "vue";

const useTaxonomiesQuery = () => {
  const data = ref<DayExperienceTaxonomy>();
  const isLoading = ref(false);

  const getTaxonomies = () => {
    isLoading.value = true;
    return dayExperienceService
      .getTaxonomies()
      .then((tax) => {
        data.value = tax;
      })
      .finally(() => {
        isLoading.value = false;
      });
  };

  getTaxonomies();

  return {
    data,
    isLoading,
  };
};

export default useTaxonomiesQuery;
